// src/components/dashboard/admin/AdminSidebar.jsx
import { Link, useLocation } from 'react-router-dom';
import { 
  FaTachometerAlt, 
  FaUsers, 
  FaFileAlt, 
  FaChartBar, 
  FaImages,
  FaCog,
  FaDollarSign,
  FaHome,
  FaTools
} from 'react-icons/fa';

const AdminSidebar = () => {
  const location = useLocation();

  const menuItems = [
    {
      name: 'Dashboard',
      href: '/admin/dashboard',
      icon: FaTachometerAlt
    },
    {
      name: 'Customers',
      href: '/admin/customers',
      icon: FaUsers
    },
    {
      name: 'Properties',
      href: '/admin/properties',
      icon: FaHome
    },
    {
      name: 'Services',
      href: '/admin/services',
      icon: FaTools
    },
    {
      name: 'Quotes',
      href: '/admin/quotes',
      icon: FaFileAlt
    },
    {
      name: 'Payments',
      href: '/admin/payments',
      icon: FaDollarSign
    },
    {
      name: 'Analytics',
      href: '/admin/analytics',
      icon: FaChartBar
    },
    {
      name: 'Gallery',
      href: '/admin/gallery',
      icon: FaImages
    },
    {
      name: 'Settings',
      href: '/admin/settings',
      icon: FaCog
    }
  ];

  const isActive = (href) => {
    return location.pathname === href || location.pathname.startsWith(href + '/');
  };

  return (
    <aside className="w-64 bg-white shadow-sm border-r border-gray-200 min-h-screen">
      <nav className="mt-6 px-3">
        <div className="space-y-1">
          {menuItems.map((item) => {
            const IconComponent = item.icon;
            const active = isActive(item.href);
            
            return (
              <Link
                key={item.name}
                to={item.href}
                className={`
                  group flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors duration-200
                  ${active 
                    ? 'bg-primary-100 text-primary-700 border-r-2 border-primary-700' 
                    : 'text-gray-700 hover:text-gray-900 hover:bg-gray-50'
                  }
                `}
              >
                <IconComponent 
                  className={`
                    flex-shrink-0 -ml-1 mr-3 h-5 w-5 transition-colors duration-200
                    ${active ? 'text-primary-600' : 'text-gray-400 group-hover:text-gray-500'}
                  `}
                />
                <span className="truncate">{item.name}</span>
              </Link>
            );
          })}
        </div>
      </nav>
    </aside>
  );
};

export default AdminSidebar;